export default __webpack_public_path__ + "static/media/Rubik-Italic-VariableFont_wght.13ee8a16.ttf";